<template>
  <div class="body evel-II" style="">
    <div class="bg-white" v-if="!showDefinition">
      <!--培训课件  -->

      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-row class="layer-header-front">
          <el-col :span="24" >
            <el-form-item label="课件名称" prop="dataName" class="item">
              <el-input v-model="form.dataName" :disabled="$route.query.type == 'check'" style="width: calc(100% - 160px);"></el-input>
              <el-button class="fa-pull-right" style="float: right;" @click="$router.back(-1)">返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row class="pl20">
            <el-col :span="8" class="pr20">
              <el-form-item label="教师名称" prop="teacherName" class="item">
                <!-- <el-input :disabled="$route.query.type == 'check'" v-model="form.teacherName"></el-input> -->
                <el-select
                v-model="form.teacherId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
          <!-- <el-col :span="8" class="pr20">
            <el-form-item label="目录" prop="questionsDirectoryId">
              <selectTree :disabled="$route.query.type == 'check'" :props="{
                value: 'id', // ID字段名
                label: 'directoryName', // 显示名称
                children: 'directoryList' // 子级字段名
              }" :options="catalogList" :value="form.questionsDirectoryId" @getValue="directoryChange"></selectTree>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="pr20">
            <el-form-item label="行业类别" prop="professionalCategory">
              <dictionarySelect :disabled="$route.query.type == 'check'" ref="dictionarySelect"
                :parentCode="$const.dictionary.TRAINING_INDUSTRY" :filter="true"
                @submit="professionalCategorySubmitHandle" clearable></dictionarySelect>

            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row class="pl20">
          <el-col :span="24" class="pr20">
            <el-form-item label="课件简介" prop="dataIntroduction">
              <el-input :disabled="$route.query.type == 'check'" type="textarea"  rows="6"
                v-model="form.dataIntroduction"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!--培训课件  -->
        <!-- <div class="allType">
          <el-radio-group v-model="allType">
            <el-radio-button :label="1">视频</el-radio-button>
            <el-radio-button :label="2">图文</el-radio-button>
          </el-radio-group>
        </div> -->
        <div>
          <el-button type="primary" class="ml20" icon="el-icon-plus" v-if="$route.query.type != 'check'" @click="addResource">新增视频
          </el-button>

          <el-table :data="tableData" style="width: 100%;margin:20px 0px;">
            <el-table-column prop="resourcesName" label="培训资源名称">
              <template slot-scope="scope">
                <el-input :disabled="$route.query.type == 'check'" v-model="scope.row.resourcesName"
                  placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="resourcesSort" label="排序">
              <template slot-scope="scope">
                <template>
                  <el-input-number :disabled="$route.query.type == 'check'" v-model="scope.row.resourcesSort" :min="1"  label="请输入排序"></el-input-number>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="suggestedDuration" label="建议时长(分钟)">
              <template slot-scope="scope">
                <template v-if="scope.row.suggestedDurationMax">
                  <el-input-number :disabled="$route.query.type == 'check'" v-model="scope.row.suggestedDuration" :min="1"
                    :max="scope.row.suggestedDurationMax" label="请输入资料学习时长（单位：分钟）"></el-input-number>
                </template>
                <template v-else>
                  <el-input-number :disabled="$route.query.type == 'check'" v-model="scope.row.suggestedDuration" :min="1"
                    label="请输入资料学习时长（单位：分钟）"></el-input-number>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="附件">
              <template slot-scope="scope">
                <template type="success" v-if="scope.row.resourcesPath">
                  <span v-if="scope.row.resourcesType == 1"
                    v-html="'视频文件' + (scope.row.suggestedDurationMax ? ',时长' + scope.row.suggestedDurationMax + '分钟' : '')">
                  </span>
                  <span v-else>
                    PDF文件
                  </span>
                </template>
                <div v-else @click="selectTableIndex(scope.$index)">
                  <el-upload-e :dir="ossConstant.dir.courseware" @onBefore="uploadBefore" @onSuccess="uploadSuccess"
                    :accept="'.mp4,.pdf'"></el-upload-e>
                  <div class="el-upload__tip" slot="tip">支持上传.mp4，.pdf文件</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="success" v-if="scope.row.resourcesType == 1"
                  @click="definition(scope.row, scope.$index, $route.query.type)">上传清晰度
                </el-button>

                <el-button type="success" v-if="scope.row.resourcesPath"
                  @click="preview(scope.row.resourcesUrl, scope.row.resourcesType)">预览
                </el-button>

                <el-button type="danger" v-if="$route.query.type != 'check'"
                  @click="delResource(scope.row.resourcesFileId, scope.$index)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-divider></el-divider>
        <div>
          <el-button type="primary" class="ml20" icon="el-icon-plus" v-if="$route.query.type != 'check'" @click="addImgText">新增图文
          </el-button>
          <el-table :data="tableDataImgText" style="width: 100%;margin:20px 0px;">
            <el-table-column prop="resourcesName" label="名称">
              <template slot-scope="scope">
                <div>{{scope.row.resourcesName}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="resourcesSort" label="排序">
              <template slot-scope="scope">
                {{scope.row.resourcesSort}}
              </template>
            </el-table-column>
            <el-table-column prop="resourcesName" label="类型">
              <template >
                <div>图文</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="editImgText(scope.row, scope.$index)">编辑
                </el-button>
                <el-button type="danger" @click="delImgText(scope.row.resourcesFileId, scope.$index)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--        &lt;!&ndash;关联考试  &ndash;&gt;-->
        <!--        <div class="f&#45;&#45;c mb20">-->
        <!--          <h2>关联考试</h2>-->
        <!--          <div class="hr"></div>-->
        <!--        </div>-->
        <!--        <el-button-->
        <!--          type="primary"-->
        <!--          icon="el-icon-plus"-->
        <!--          @click="showCorrelationExam"-->
        <!--        >关联考试-->
        <!--        </el-button-->
        <!--        >-->
        <!--        <el-table :data="dataList3" style="width: 100%;margin:20px 0px;">-->
        <!--          <el-table-column-->
        <!--            prop="questionsPaperName"-->
        <!--            label="试卷名称"-->
        <!--          ></el-table-column>-->
        <!--          <el-table-column label="试卷类型">-->
        <!--            <template slot-scope="scope">{{-->
        <!--                scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷"-->
        <!--              }}-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--            prop="questionNumber"-->
        <!--            label="包含题目数量"-->
        <!--          ></el-table-column>-->
        <!--        </el-table>-->
        <!--        &lt;!&ndash; 关联考试 &ndash;&gt;-->
        <!--        <el-dialog-->
        <!--          title="关联考试"-->
        <!--          :visible.sync="isShowCorrelationExam"-->
        <!--          width="70%"-->
        <!--        >-->
        <!--          <el-form-->
        <!--            ref="correlationExamFormRef"-->
        <!--            :model="correlationExamForm"-->
        <!--            label-width="80px"-->
        <!--          >-->
        <!--            <el-row>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item label="试卷名称" prop="questionsPaperName">-->
        <!--                  <el-input-->
        <!--                    :disabled="$route.query.type == 'check'"-->
        <!--                    v-model="correlationExamForm.questionsPaperName"-->
        <!--                  ></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="1">-->
        <!--                <div style="height:1px;"></div>-->
        <!--              </el-col>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item label="试卷类型" prop="selectionMode">-->
        <!--                  <el-select v-model="correlationExamForm.selectionMode">-->
        <!--                    <el-option label="固定试卷" value="1"></el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->

        <!--            <el-row>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item label="是否开卷" prop="openBook" class="item">-->
        <!--                  <el-select v-model="correlationExamForm.openBook">-->
        <!--                    <el-option label="开卷" value="0"></el-option>-->
        <!--                    <el-option label="闭卷" value="1"></el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="1">-->
        <!--                <div style="height:1px;"></div>-->
        <!--              </el-col>-->
        <!--              <el-col :span="12">-->
        <!--                <el-form-item>-->
        <!--                  <el-button type="primary" @click="getPaperList">搜索</el-button>-->
        <!--                  <el-button-->
        <!--                    type="primary"-->
        <!--                    @click="resetForm('correlationExamFormRef')"-->
        <!--                  >重置-->
        <!--                  </el-button-->
        <!--                  >-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--          </el-form>-->
        <!--          &lt;!&ndash; 试卷列表 &ndash;&gt;-->
        <!--          <el-table :data="paperList" @selection-change="selectionChange2">-->
        <!--            <el-table-column type="selection"></el-table-column>-->
        <!--            <el-table-column-->
        <!--              property="questionsPaperName"-->
        <!--              label="试卷名称"-->
        <!--            ></el-table-column>-->
        <!--            <el-table-column property="name" label="试卷类型">-->
        <!--              <template slot-scope="scope">{{-->
        <!--                  scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷"-->
        <!--                }}-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              property="department"-->
        <!--              label="所属部门"-->
        <!--            ></el-table-column>-->
        <!--            <el-table-column-->
        <!--              property="questionNumber"-->
        <!--              label="包含题目数量"-->
        <!--            ></el-table-column>-->
        <!--            <el-table-column label="是否开卷">-->
        <!--              <template slot-scope="scope">{{-->
        <!--                  scope.row.openBook == 0 ? "开卷" : "闭卷"-->
        <!--                }}-->
        <!--              </template>-->
        <!--            </el-table-column>-->
        <!--          </el-table>-->
        <!--          <el-pagination-->
        <!--            style="margin-top:20px;"-->
        <!--            background-->
        <!--            layout="prev, pager, next"-->
        <!--            :total="total2"-->
        <!--            :page-size="pageSize2"-->
        <!--            @current-change="pageChange2"-->
        <!--          ></el-pagination>-->
        <!--          &lt;!&ndash;  &ndash;&gt;-->
        <!--          <span slot="footer" style="float:right;" class="p10">-->
        <!--        <el-button @click="isShowCorrelationExam = false">取 消</el-button>-->
        <!--        <el-button type="primary" @click="confirm2">确 定</el-button>-->
        <!--      </span>-->
        <!--        </el-dialog>-->

        <div class="searchBut">
          <el-button v-if="$route.query.type != 'check'" type="primary" @click="save" :loading="saveLoading">保存
          </el-button>
          <el-button type="primary" @click="$router.back(-1)">返回</el-button>
        </div>
      </el-form>
    </div>

    <el-dialog title="预览" :visible.sync="dialogVisible" width="80%" modal @close="previewDialogClose()">
      <div style="width:100%;height:100%;padding:100px;" class="f-c-c">
        <trainingVideo ref="trainingVideo" :sourceUrl="resourcePath"></trainingVideo>
        <!--        <video :src="resourcePath" controls></video>-->
      </div>
    </el-dialog>



    <definition-video ref="definitionVideo" @videoConfirm="videoConfirm()" :dataName="form.dataName" @isShowDefinition="isShowDefinition"
      :forbidden="$route.query.type != 'check'" @closePop="closePop"></definition-video>
    
    <div v-if="dialogVisible_imgText">
      <el-dialog title="培训资源" :visible.sync="dialogVisible_imgText" width="80%" modal @close="previewDialogClose2()">
      <div style="width:100%;height:630px;padding:20px;overflow-y: auto;">
        <el-form label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form_imgText.resourcesName"></el-input>
          </el-form-item>
          <el-form-item label="副标题">
            <el-input v-model="form_imgText.subTitle"></el-input>
          </el-form-item>
          <el-form-item label="摘要">
            <el-input v-model="form_imgText.summary"></el-input>
          </el-form-item>
          <el-form-item label="建议时长">
            <el-input v-model="form_imgText.suggestedDuration"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="form_imgText.resourcesSort"></el-input-number>
          </el-form-item>
          <el-form-item label="缩略图">
            <el-upload-e :dir="ossConstant.dir.mallCoursewareImage"
                  listType="picture"
                  :limit="upload.imgLimit"
                  :fileList="form_imgText.thumbnail"
                  :multiple="upload.isMultiple"
                  @onRemove="handleRemove"
                  @onSuccess="handleAvatarSuccess"
                  :showFileList="false"
                  :accept="'.png,.jpg'">
                  <el-button size="small" type="text" icon="el-icon-upload">点击上传</el-button>
            </el-upload-e>
            <div v-if="form_imgText.thumbnail">
              <img :src="form_imgText.thumbnail" alt="">
            </div>
          </el-form-item>
        </el-form>
        <div style="width:100%;height:330px;" v-if="editorOption">
          <quillEditor
            v-model="form_imgText.content"
            ref="myQuillEditor"
            :options="editorOption"
            class="editer"
          ></quillEditor>
          <div style="display: none;">
            <el-upload-e :customId="'imgInput'" :dir="ossConstant.dir.courseware" @onBefore="uploadBefore2" @onSuccess="uploadSuccess2" :accept="'.mp4'"></el-upload-e>
          </div>
        </div>
        <div class="searchBut_btn">
          <el-button @click="addImgTextBtn">添加</el-button>
        </div>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "../../api/new/training.js";
import api_dept from "../../api/api_dept.js";
import exam from "@/api/new/exam.js";
import selectTree from "@/components/common/selectTree";
import trainingVideo from "@/components/training/trainingVideo";
import elUploadE from "@/components/common/oss/ossUploadMultiple";
import ATT_API from "@/api/api_att";
import $const from "@/common/constant";
import dictionarySelect from "@/components/common/dictionarySelect";
import $ossConstant from "@/components/common/oss/ossConstant";
import DefinitionVideo from "@/pages/trainingManagement/component/definition/definitionVideo.vue"
import {quillEditor, Quill} from "vue-quill-editor";
import API from "@/api/api_user";
import {container, ImageExtend, QuillWatch} from 'quill-image-extend-module'
import ossApi from "@/api/oss/api_oss.js";
import * as Quill1 from 'quill'

Quill.register('modules/ImageExtend', ImageExtend);
// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{header: 1}, {header: 2}],
  [{list: "ordered"}, {list: "bullet"}],
  [{script: "sub"}, {script: "super"}],
  [{indent: "-1"}, {indent: "+1"}],
  [{direction: "rtl"}],
  [{size: ["small", false, "large", "huge"]}],
  [{header: [1, 2, 3, 4, 5, 6, false]}],
  [{color: []}, {background: []}],
  [{font: []}],
  [{align: []}],
  ["clean"],
  ["image", "video"]
];

export default {
  components: { selectTree, elUploadE, trainingVideo, dictionarySelect, DefinitionVideo, quillEditor },
  data() {
    return {
      $const: $const,
      ossConstant: $ossConstant,
      id: 0,
      form: {
        dataName: "",
        dataIntroduction: "",

        professionalCategoryName: "", // 专业类别名称
        professionalCategory: "", // 专业类别
        professionalCategoryItem: "",
        professionalCategorySubItem: "",

        department: "", //部门
        // departmentId: "", // 部门id
        questionsDirectoryId: "",
        teacherName: undefined,
        teacherId: null
      },
      rules: {
        dataName: [
          { required: true, message: "请输入课件名称", trigger: "blur" }
        ],
        dataIntroduction: [
          { required: true, message: "请输入课件简介", trigger: "blur" }
        ],
        // professionalCategory: [
        //   {required: true, message: "请输入专业类别", trigger: "blur"}
        // ],
        // departmentId: [
        //   { required: true, message: "请选择部门", trigger: "blur" }
        // ],
        // questionsDirectoryId: [
        //   { required: false, message: "请选择目录", trigger: "blur" }
        // ],
        // teacherName: [
        //   { required: true, message: "教师名不能为空", trigger: "blur" }
        // ],
        teacherId: [
          { required: true, message: "教师名不能为空", trigger: "blur" }
        ],
      },
      tableData: [],
      departmentList: [], //部门列表
      resourcePath: "", // 资源路径
      dialogVisible: false,
      catalogList: [],
      selectCatalogue: {},

      uploadUrl: "",
      headers: {
        Authorization: ""
      },
      deptTree: [],
      dept: {},

      isShowCorrelationExam: false,
      page2: 1,
      pageSize2: 20,
      total2: 0,
      correlationExamForm: {
        openBook: undefined,
        selectionMode: undefined,
        questionsPaperName: undefined
      },
      selectPaperList: [],
      dataList3: [],
      saveLoading: false,
      professionalCategoryCheckValue: undefined,
      showDefinition: false,
      // allType: 1, // 视频1，图文2
      tableDataImgText: [],
      dialogVisible_imgText: false,
      upload: {
        dialogImageUrl: '',
        dialogVisible: true,
        productImgs: [],
        isMultiple: true,
        imgLimit: 1,
        action: process.env.API_ROOT + "/api-base/sysAtt/save"
      },
      // 富文本
      editorOption: null,
      form_imgText: {
        resourcesName: '',
        subTitle: '',
        thumbnail: [],
        summary: '',
        resourcesType: 0,
        content: '',
        suggestedDuration: null,
        resourcesSort: null
      },
      userList: [],
      fileUrl: '',
      ossToken: '',
      ossAction: '',
      addRange: [], // 视频
      fullscreenLoading: false,
      uploadType: ''
    };
  },
  mounted() {
    // 为图片ICON绑定事件  getModule 为编辑器的内部属性
    // this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);

    this.id = this.$route.query.id;
    this.getDataDetail();
    this.getDepartmentList();
    this.getCatalogList();
    this.getUserList();
    this.uploadUrl =
      process.env.API_ROOT + "/clouddo-tranning/training/resources/data/upload";
    this.headers.Authorization = window.localStorage.getItem("access-token");
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));

  },
  methods: {
    videoConfirm(data, index) {
      // console.log(data)
      this.$set(this.tableData, index, data)
      // console.log(this.tableData[index])
    },
    isShowDefinition(flag) {
      console.log(flag)
      this.showDefinition = flag
    },
    closePop(data, index) {
      // console.log('课件详情页', this.tableData)
      this.$set(this.tableData, index, data)
    },
    definition(row, index, type) {

      // console.log(row)
      let definitionVideo = []
      api.definitionByResourcesId({ trainingResourcesId: row.id }).then(res => {
        // console.log(res)
        if (res.code === 0 && res.data) {
          // console.log(row.definitionVideo)
          // console.log("------------ok")
          if (row.definitionVideo != undefined && row.definitionVideo.length<=res.data.length) {
            definitionVideo = res.data;
          } else {
            // definitionVideo = row.definitionVideo
            if ( row.definitionVideo != undefined  ) {
              definitionVideo = row.definitionVideo
            } else {
              definitionVideo = res.data;
            }
          }
          this.$refs.definitionVideo.show(row, index, definitionVideo)
        } else {
          this.$refs.definitionVideo.show(row, index, definitionVideo)
        }
      })

    },

    clearProfessionalCategory() {
      this.form.professionalCategory = undefined;
      this.form.professionalCategoryItem = undefined;
      this.form.professionalCategorySubItem = undefined;
    },
    professionalCategorySubmitHandle(data) {
      this.clearProfessionalCategory();
      if (data) {
        this.form.professionalCategoryName = data.pathTextName;
        this.buildProfessionalCategory(data.node);
      }
    },
    buildProfessionalCategory(node) {
      if (node.level == 1) {
        this.form.professionalCategory = node.data.object.code;
      }
      if (node.level == 2) {
        this.form.professionalCategoryItem = node.data.object.code;
      }
      if (node.level == 3) {
        this.form.professionalCategorySubItem = node.data.object.code;
      }
      if (node.parent) {
        this.buildProfessionalCategory(node.parent);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    directoryChange(v) {
      this.selectCatalogue = v;
      this.form.questionsDirectoryId = v.id;
    },
    // deptChange(v) {
    //   this.dept = v;
    //   this.form.departmentId = v.id;
    // },
    getCatalogList() {
      exam
        .getCatalogList({
          type: 3,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    //获取部门列表
    getDepartmentList() {
      this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    },
    /**
     * 培训课件单条详情
     */
    getDataDetail() {
      if (!this.id) return;
      api.getDataDetail({ dataId: this.id }).then(res => {
          this.form.dataName = res.data.dataName;
          this.form.dataIntroduction = res.data.dataIntroduction;
          this.form.dataName = res.data.dataName;
          this.form.professionalCategory = res.data.professionalCategory; // 专业类别
          this.form.professionalCategoryItem = res.data.professionalCategoryItem;
          this.form.professionalCategorySubItem = res.data.professionalCategorySubItem;
          this.form.professionalCategoryName = res.data.professionalCategoryName;
          // this.form.createdBy = res.data.createdBy;
          this.form.department = res.data.department;
          // this.form.departmentId = Number(res.data.departmentId);
          this.form.questionsDirectoryId = res.data.questionsDirectoryId;
          this.form.teacherName = res.data.teacherName;
          this.form.teacherId = res.data.teacherId;
          // this.tableData = _.orderBy(res.data.trainingResourcesDetailVos, ['resourcesSort'], ['asc']);
          // this.tableData = _.orderBy(res.data.videoResourcesDetailVos, ['resourcesSort'], ['asc']);
          this.tableData = res.data.videoResourcesDetailVos;
          this.tableDataImgText = res.data.imgTextResourcesDetailVos;

          if (res.data.professionalCategoryCheckValue) {
            this.$refs.dictionarySelect.setChecked(res.data.professionalCategoryCheckValue, res.data.professionalCategoryName);
          }
          if (res.data.joinPaperVos) {
            this.dataList3 = res.data.joinPaperVos;
            this.dataList3.forEach(t => {
              t.questionNumber = t.questionsNumber;
            })
          }
        });
    },
    save() {
      this.$refs.form.validate(validate => {
        if (validate == false) return;

        if (
          !this.form.dataName ||
          !this.form.dataIntroduction 
          // ||
          // !this.form.questionsDirectoryId
          // !this.form.professionalCategory
        )
          return this.$message.error("请完善课件信息");
        if (this.tableData.length > 0) {
          let data = this.tableData[this.tableData.length - 1];
          if (
            !data.resourcesName ||
            !data.resourcesPath ||
            !data.suggestedDuration
          ) {
            return this.$message.error("请完善表格信息");
          }
        } else {
          // return this.$message.error("请新增课件附件");
        }
        if (this.tableData) {
          for (let i = 0; i < this.tableData.length; i++) {
            let obj = this.tableData[i];
            // console.log(obj.suggestedDurationMax && obj.suggestedDurationMax < obj.suggestedDuration);
            if (obj.suggestedDurationMax && obj.suggestedDurationMax < obj.suggestedDuration) {
              return this.$message.error("附件视频【" + obj.resourcesName + "】 建议时长不能超过视频本身时长。最大只能填【" + obj.suggestedDurationMax + "】分钟");
              return;
            }
            if (!obj.resourcesSort && obj.resourcesSort !== 0) {
              return this.$message.error("请输入排序");
              return;
            }
          }
          this.tableData.forEach(function (item) {
            delete item.resourcesUrl;
            delete item.dataPrice;
            delete item.expireDay;
          });
        }
        if (this.tableDataImgText) {
          let status = false;
          this.tableDataImgText.forEach((item) => {
            if (!item.resourcesSort && item.resourcesSort !== 0) {
              status = true;
            }
          })
          if (status) {
            this.$message.error("请输入排序");
            return;
          }
        }
        // console.log(this.tableData)
        let p = {
          dataName: this.form.dataName,
          // teacherName: this.form.teacherName,  // 教师名称
          teacherId: this.form.teacherId,
          dataIntroduction: this.form.dataIntroduction,

          professionalCategoryName: this.form.professionalCategoryName,
          professionalCategory: this.form.professionalCategory,
          professionalCategoryItem: this.form.professionalCategoryItem,
          professionalCategorySubItem: this.form.professionalCategorySubItem,

          questionsDirectoryId: this.form.questionsDirectoryId,
          // trainingResourcesSaveDtos: this.allType === 1 ? this.tableData : this.tableDataImgText, // 1/2 todo
          videoResourcesSaveDtos: this.tableData,
          imgTextResourcesSaveDtos: this.tableDataImgText,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
        };

        if (this.id) p.id = this.id;

        if (p.questionsDirectoryId) {
          p.questionsDirectoryName = this.selectCatalogue.text;
          // this.catalogList.forEach(v => {
          //   if (v.id == p.questionsDirectoryId) {
          //     p.questionsDirectoryName = v.directoryName;
          //   }
          // });
        }
        // p.department = this.departmentList.filter((v, i) => {
        //   return v.id == this.form.departmentId;
        // })[0].deptName;
        p.department = this.dept.text;
        //关联试卷
        p.joinPaperSaveDtos = [];
        this.dataList3.forEach(v => {
          p.joinPaperSaveDtos.push({
            questionsPaperId: v.id || v.questionsPaperId,
            questionsPaperName: v.questionsPaperName,
            questionsPaperType:
              v.selectionMode !== undefined
                ? v.selectionMode
                : v.questionsPaperType,
            questionsNumber:
              v.questionNumber !== undefined
                ? v.questionNumber
                : v.questionNumber
          });
        });
        this.saveLoading = true;
        api.postData(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.saveLoading = false;
            this.$message.error(res.message);
          }
        });
      });
    },
    addResource() {
      if (this.tableData.length == 0) {
        this.tableData.push({
          resourcesName: "",
          resourcesPath: "",
          // resourcesType: 1, // 0:pdf,1:视频
          suggestedDuration: "" // 建议时长
        });
      } else {
        let data = this.tableData[this.tableData.length - 1];
        if (
          !data.resourcesName ||
          !data.resourcesPath ||
          !data.suggestedDuration
        ) {
          return this.$message.error("请完善表格信息再新增数据");
        }

        this.tableData.push({
          resourcesName: "",
          resourcesPath: "",
          resourcesUrl: "",
          suggestedDuration: "" // 建议时长
        });
      }
    },
    /**
     * 预览视频或pdf
     * resourcesType: 0:pdf,  1:视频
     */
    preview(resourcePath, resourcesType) {
      if (resourcesType == 1) {
        this.resourcePath =
          resourcePath.indexOf("http") > -1
            ? resourcePath
            : "http://" + resourcePath;
        this.dialogVisible = true;
      } else {
        window.open(
          resourcePath.indexOf("http") > -1
            ? resourcePath
            : "http://" + resourcePath
        );
      }
    },
    /**
     * 当预览弹出关闭时
     **/
    previewDialogClose() {
      //暂停视频
      this.$refs.trainingVideo.pause();
    },
    /**
     * 删除资源
     */
    delResource(resourcesFileId, index) {
      this.tableData.splice(index, 1);
      if (!resourcesFileId) return;
      ATT_API
        .delAttByIds({
          ids: resourcesFileId
        })
        .then(res => {
          this.$message.error(res.message);
        });
    },
    /**
     * 获取时长度
     */
    getTimes(file) {
      let content = file;
      let url = URL.createObjectURL(content);
      let audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", (_event) => {
        let num = Math.floor(audioElement.duration / 60) > 0 ? Math.floor(audioElement.duration / 60) : 1;
        this.tableData[this.tableIndex].suggestedDuration = num;
        this.tableData[this.tableIndex].suggestedDurationMax = num;
      });
    },
    /**
     * 上传之前
     **/
    uploadBefore(file) {
      let fileType = file.name.split('.').pop().toLowerCase();
      if (fileType == 'mp4') {
        this.getTimes(file);
      }
    },
    /**
     * 上传文件成功回调
     */
    uploadSuccess(e, data) {
      this.tableData[this.tableIndex].resourcesUrl = data.url;
      this.tableData[this.tableIndex].resourcesPath = data.name;
      // this.tableData[this.tableIndex].resourcesFileId = data.hash
      if (data.name.indexOf(".pdf") > -1 || data.name.indexOf(".PDF") > -1) {
        this.tableData[this.tableIndex].resourcesType = 0;
      } else {
        this.tableData[this.tableIndex].resourcesType = 1;
      }
    },
    selectTableIndex(index) {
      this.tableIndex = index;
    },
    //
    selectChange(departmentId, department) {
      // console.log(arguments);
    },
    // 关联考试相关方法
    showCorrelationExam() {
      this.isShowCorrelationExam = true;
      this.getPaperList();
    },
    getPaperList() {
      let p = {
        ...this.correlationExamForm,
        page: this.page,
        pageSize: this.pageSize,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      exam.getPaperList(p).then(res => {
        this.paperList = res.data.records;
        this.total2 = res.data.total;
      });
    },
    // 关联考试,确定
    confirm2() {
      this.selectPaperList.forEach(v => {
        this.dataList3.forEach(v2 => {
          if (v.id == v2.id || v.id == v2.questionsPaperId) {
            this.isShowCorrelationExam = false;
            throw "已经存在";
          }
        });
      });

      this.selectPaperList.forEach(v => {
        this.dataList3.push(v);
      });
      this.isShowCorrelationExam = false;
    },
    selectionChange2(e) {
      this.selectPaperList = e;
    },
    // 图文新增
    addImgText() {
      this.dialogVisible_imgText = true;
      this.form_imgText = {
        resourcesName: '',
        subTitle: '',
        thumbnail: [],
        summary: '',
        resourcesType: 0,
        content: '',
        suggestedDuration: null,
        resourcesSort: null
      }
      this.getToken();
      // 为图片ICON绑定事件  getModule 为编辑器的内部属性
      setTimeout(() => {
        this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);
      }, 200);
    },
    previewDialogClose2(){
      this.dialogVisible_imgText = false;
    },
    handleAvatarSuccess(res, data) {//图片上传成功
      console.log('handleAvatarSuccess', res, data);
      console.log('form_imgText.thumbnail', this.form_imgText.thumbnail);
      this.form_imgText.thumbnail = [data.url];
    },
    addImgTextBtn() {
      console.log('this.form_imgText1', this.form_imgText);
      let params = JSON.parse(JSON.stringify(this.tableDataImgText));
      let params2 = JSON.parse(JSON.stringify(this.form_imgText));
      if (!this.form_imgText.resourcesSort && this.form_imgText.resourcesSort !== 0) {
        this.$message.error("请输入排序");
        return
      }
      if (typeof this.form_imgText.index === 'number') {
        // 编辑
        params2.thumbnail = this.form_imgText.thumbnail[0] || '';
        params[this.form_imgText.index] = params2;
        console.log('this.form_imgText2', params);
        this.tableDataImgText = params;
      } else {
        // 新增
        params2.thumbnail = this.form_imgText.thumbnail[0] || '';
        this.tableDataImgText.push(params2);
        console.log(' addImgTextBtn tableDataImgText', this.tableDataImgText);
      }
      this.dialogVisible_imgText = false;
    },
    delImgText(id, index) {
      console.log('delImgText1', id, index);
      let params = JSON.parse(JSON.stringify(this.tableDataImgText));
      params.splice(index, 1);
      console.log('delImgText2', params);
      this.tableDataImgText = params;
      console.log('delImgText3', this.tableDataImgText);
    },
    editImgText(row, index) {
      console.log('editImgText', row, index);
      this.dialogVisible_imgText = true;
      this.form_imgText = Object.assign({}, {
          resourcesName: '',
          subTitle: '',
          thumbnail: [],
          summary: '',
          resourcesType: 0,
          content: '',
          suggestedDuration: null,
          index: index
        }, row
      )
      this.form_imgText.thumbnail = row.thumbnail ? [row.thumbnail] : []
      this.getToken();
      // 为图片ICON绑定事件  getModule 为编辑器的内部属性
      setTimeout(() => {
        this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler);
      }, 200);
    },
    getUserList() {
      API.pageList({
        page: 0,
        pageSize: 10000,
        post: '培训部'
      }).then(result => {
        console.log('getUserList', result.page.records);
        if (result && result.page && result.page.records.length > 0) {
          this.userList = result.page.records;
        }
      });
    },
    getToken() {
      ossApi.token({}).then(res => {
        console.log('ossApi', res);
        this.ossToken = res.token;
        this.ossAction = res.action;
        this.editorOption = {
          //  富文本编辑器配置
          placeholder: "",
          theme: "snow", // 主题
          modules: {
            // 新增下面
            imageDrop: true, // 拖动加载图片组件。
            imageResize: {
              //调整大小组件。
              displayStyles: {
                backgroundColor: "black",
                border: "none",
                color: "white"
              },
              modules: ["Resize", "DisplaySize", "Toolbar"]
            },
            ImageExtend: {
              name: 'file',
              // 更多配置见官方文档https://www.kancloud.cn/liuwave/quill/1434141
              // 设置请求头部
              headers: (xhr) => {
                // xhr.setRequestHeader('Authorization', Vue.ls.get(ACCESS_TOKEN))
              },
              action: this.ossAction, // 这里写入请求后台地址 例如："http://xxx.xxx.xxx.xxx:xxx/api/file/upload/indexFile",
              response: (res) => {
                console.log('ImageExtend res', res);
                // return res.url // 这里写入请求返回的数据，也就是一个图片字符串
                // let url = undefined;
                // await ossApi.privateDownloadUrl({
                //   fileName: res.key
                // }).then(res => {
                //   url = res.url;
                //   // return res.url;
                // }).catch(res => {
                // });
                // console.log('response1', url);
                console.log('response2', 'http://attach.gee4.cn/' + res.key);
                console.log('response3', 'https://elearning.sisley-eba.com.cn/attach/' + res.key);
                // return url;
                // return 'http://attach.gee4.cn/' + res.key;
                return 'https://elearning.sisley-eba.com.cn/attach/' + res.key;
              },
              change: (xhr, formData) => {
                // xhr.setRequestHeader('myHeader','myValue')
                // formData.append('token', 'myToken')
                console.log('change', xhr, formData)
                const file = formData.get('file');
                const suffix = file.name.split('.');
                const ext = suffix.splice(suffix.length - 1, 1)[0];
                                //  文件名称
                formData.append('token', this.ossToken)
                formData.append('key', 'img_key' + new Date().getTime() + `.${ext}`)
              }, // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
              end: () => {
                  // getToken(); // 每次完成后刷新token
              },
              success: () => {
                console.log('form_imgText.content', this.form_imgText.content);
              },
              error: (e) => {
                console.log('error', e)
              },
            },
            toolbar: {
              // container: container,
              container: toolOptions, // 工具栏选项
              // handlers: handlers // 事件重写
              handlers: {
                'image': function () {
                  QuillWatch.emit(this.quill.id)
                }
              }
            }
          },
        }
        console.log('this.editorOption', this.editorOption);
      }).catch(res => {
      });
    },
    /**
     * 上传之前
     **/
     uploadBefore2(file) {
      let fileType = file.name.split('.').pop().toLowerCase();
      // if (fileType == 'mp4') {
      //   this.getTimes(file);
      // }
    },
    /**
     * 上传文件成功回调
     */
    uploadSuccess2(e, data) {
      console.log('uploadSuccess2', data);
      this.fullscreenLoading = false;
      let vm = this
      if (data && data.url) {  // 将文件上传后的URL地址插入到编辑器文本中
        let value = data.url
        vm.addRange = vm.$refs.myQuillEditor.quill.getSelection();
        value = value.indexOf('http') !== -1 ? value : 'http:' + value;
        vm.$refs.myQuillEditor.quill.insertEmbed(vm.addRange !== null ? vm.addRange.index : 0, vm.uploadType, value, Quill1.sources.USER)   // 调用编辑器的 insertEmbed 方法，插入URL
      } else {
        this.$message.error(`${vm.uploadType}插入失败`)
      }
      // this.tableData[this.tableIndex].resourcesUrl = data.url;
      // this.tableData[this.tableIndex].resourcesPath = data.name;
      // // this.tableData[this.tableIndex].resourcesFileId = data.hash
      // if (data.name.indexOf(".pdf") > -1 || data.name.indexOf(".PDF") > -1) {
      //   this.tableData[this.tableIndex].resourcesType = 0;
      // } else {
      //   this.tableData[this.tableIndex].resourcesType = 1;
      // }
    },
    // 点击视频ICON触发事件
    videoHandler(state) {
      console.log('videoHandler', state);
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (state) {
        let fileInput = document.getElementById('imgInput')
        fileInput.click() // 加一个触发事件
      }
      this.uploadType = 'video'
    }
  }
};
</script>

<style>
.el-form-item__label {
  white-space: nowrap;
}

.required {
  color: red;
}
.allType{
  text-align: center;
}
.editer {
  height: 300px;
}
.searchBut_btn{
  clear: both;
  text-align: center;
  padding: 50px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/trainingResourceDetail.vue